let APP_STATE = 'active';
export function appStateMinimized(){
    APP_STATE='background';
    onAppStateChanged()
}

export function appStateRestored(){
    APP_STATE='active';
    onAppStateChanged()
}
export const getAppState=()=>{
    return APP_STATE;
}
export const onAppStateChanged=()=>{
    window.dispatchEvent(new CustomEvent('app.state.changed',{detail:{state:getAppState()}}))
    console.log("App state changed ",getAppState())
}
